export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8161.3c51d856.jpg";